<script>
export default {
    name: 'pagination',
    // Property: current_page, last_page, show_page(page)
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        model: Object,
        goto: Function
    },
    data: function () {
        return {}
    },
    methods: {
        goTo: function (page) {
            // Make sure page between MIN & MAX
            page = Math.min(this.model.last_page, page);
            page = Math.max(page, 1);

            this.$emit('goto', page);
        },
        getListNumber: function (page) {
            // Store page list
            var list;
            // Generate number from $from to $to
            var from, to;

            // Number of page to be shown
            var n = 3;

            // ==== Generate $from to $to ====
            // If page is more than 5/2 = 2,5 => 3
            if (page > Math.ceil(n / 2)) {
                // Create margin. 5/2 = 2,5 => 2
                var margin = Math.floor(n / 2);
                // Create from
                from = page - margin;
                // Create to
                to = page + margin;

                // When reach end
                if (to >= this.model.last_page) {
                    to = this.model.last_page;
                    from = to - n + 1;
                }
            } else {
                from = 1;
                to = n;
                to = Math.min(to, this.model.last_page);
            }

            list = [];
            for (var i = from; i <= to; i++) {
                list.push(i);
            }
            // ==== /Generate $from to $to ====

            return list;
        },
        getNumber: function (page, type) {
            var from, to;

            // Number of page to be shown
            var n = 5;

            // Generate $from to $to
            if (page > Math.ceil(n / 2)) {
                var margin = Math.floor(n / 2);
                from = page - margin;
                to = page + margin;

                // When reach end
                if (to >= this.model.last_page) {
                    to = this.model.last_page;
                    from = to - n + 1;
                }
            } else {
                from = 1;
                to = n;
                to = Math.min(to, this.model.last_page);
            }

            if (type == 'first') {
                return from;
            }
            return to;
        },
        previous: function () {
            this.goTo(this.model.current_page - 1);
        },
        next: function () {
            this.goTo(this.model.current_page + 1);
        },
        first: function () {
            this.goTo(1);
        },
        last: function () {
            this.goTo(this.model.last_page);
        }
    },
    computed: {
        listNumber: function () {
            return this.getListNumber(this.model.current_page)
        }
    }
}
</script>

<template>
    <ul class="pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0"
        v-if="model.last_page > 1">
        <li class="page-item">
            <BLink :disabled="disabled" @click.prevent="first()" class="page-link"><i class="mdi mdi-chevron-double-left"></i></BLink>
        </li>
        <li class="page-item">
            <BLink :disabled="disabled" @click.prevent="previous()" class="page-link"><i class="mdi mdi-chevron-left"></i></BLink>
        </li>
        <li class="page-item" v-for="(n, index) in listNumber" :key="index"
            v-bind:class="{ 'active': n == model.current_page }">
            <BLink :disabled="disabled && n !== model.current_page" @click.prevent="goTo(n)" class="page-link">{{ n }}</BLink>
        </li>
        <li class="page-item">
            <BLink :disabled="disabled" @click.prevent="next()" class="page-link"><i class="mdi mdi-chevron-right"></i></BLink>
        </li>
        <li class="page-item">
            <BLink :disabled="disabled" @click.prevent="last()" class="page-link"><i class="mdi mdi-chevron-double-right"></i></BLink>
        </li>
    </ul>
</template>